export const GET_INITIAL_DASHBOARD_DATA = 'GET_INITIAL_DASHBOARD_DATA';
/****/
export const GET_CRS_DASHBOARD_SEGMENT_LIST_DATA =
  'GET_CRS_DASHBOARD_SEGMENT_LIST_DATA';
export const GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_FAIL =
  'GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_FAIL';
export const GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_SUCCESS =
  'GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_SUCCESS';
/****/
export const GET_CRS_MODEL_LIST_DATA = 'GET_CRS_MODEL_LIST_DATA';
export const GET_CRS_MODEL_LIST_DATA_SUCCESS =
  'GET_CRS_MODEL_LIST_DATA_SUCCESS';
export const GET_CRS_MODEL_LIST_DATA_FAIL = 'GET_CRS_MODEL_LIST_DATA_FAIL';
/****/
export const GET_CRS_CLUSTER_CHART_DATA = 'GET_CRS_CLUSTER_CHART_DATA';
export const GET_CRS_CLUSTER_CHART_DATA_SUCCESS =
  'GET_CRS_CLUSTER_CHART_DATA_SUCCESS';
export const GET_CRS_CLUSTER_CHART_DATA_FAIL =
  'GET_CRS_CLUSTER_CHART_DATA_FAIL';
/****/
export const GET_CRS_CLUSTER_FEATURES_DATA = 'GET_CRS_CLUSTER_FEATURES_DATA';
export const GET_CRS_CLUSTER_FEATURES_DATA_SUCCESS =
  'GET_CRS_CLUSTER_FEATURES_DATA_SUCCESS';
export const GET_CRS_CLUSTER_FEATURES_DATA_FAIL =
  'GET_CRS_CLUSTER_FEATURES_DATA_FAIL';
/****/
export const GET_CRS_CLUSTER_CUSTOMER_LIST_DATA =
  'GET_CRS_CLUSTER_CUSTOMER_LIST_DATA';
export const GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_SUCCESS =
  'GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_SUCCESS';
export const GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_FAIL =
  'GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_FAIL';
/****/
export const GET_CRS_FEATURE_CATEGORY_CODES = 'GET_CRS_FEATURE_CATEGORY_CODES';
export const GET_CRS_FEATURE_CATEGORY_CODES_SUCCESS =
  'GET_CRS_FEATURE_CATEGORY_CODES_SUCCESS';
export const GET_CRS_FEATURE_CATEGORY_CODES_FAIL =
  'GET_CRS_FEATURE_CATEGORY_CODES_FAIL';
/****/
export const RESET_CRS_DASHBOARD = 'RESET_CRS_DASHBOARD';

// Get initial dashboard data

export const getInitialDashboardData = (payload) => {
  return {
    type: GET_INITIAL_DASHBOARD_DATA,
    payload
  };
};

// Segment List Data

export const getCrsSegmentListData = (payload) => {
  return {
    type: GET_CRS_DASHBOARD_SEGMENT_LIST_DATA,
    payload
  };
};

export const getCrsSegmentListDataSuccess = (payload) => {
  return {
    type: GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_SUCCESS,
    payload
  };
};

export const getCrsSegmentListDataFail = (payload) => {
  return {
    type: GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_FAIL,
    payload
  };
};

// Model List Data

export const getCrsModelListData = (payload) => {
  return {
    type: GET_CRS_MODEL_LIST_DATA,
    payload
  };
};

export const getCrsModelListDataSuccess = (payload) => {
  return {
    type: GET_CRS_MODEL_LIST_DATA_SUCCESS,
    payload
  };
};

export const getCrsModelListDataFail = (payload) => {
  return {
    type: GET_CRS_MODEL_LIST_DATA_FAIL,
    payload
  };
};

// Cluster Chart Data

export const getCrsClusterChartData = (payload) => {
  return {
    type: GET_CRS_CLUSTER_CHART_DATA,
    payload
  };
};

export const getCrsClusterChartDataSuccess = (payload) => {
  return {
    type: GET_CRS_CLUSTER_CHART_DATA_SUCCESS,
    payload
  };
};

export const getCrsClusterChartDataFail = (payload) => {
  return {
    type: GET_CRS_CLUSTER_CHART_DATA_FAIL,
    payload
  };
};

// Cluster Features Data

export const getCrsClusterFeaturesData = (payload) => {
  return {
    type: GET_CRS_CLUSTER_FEATURES_DATA,
    payload
  };
};

export const getCrsClusterFeaturesDataSuccess = (payload) => {
  return {
    type: GET_CRS_CLUSTER_FEATURES_DATA_SUCCESS,
    payload
  };
};

export const getCrsClusterFeaturesDataFail = (payload) => {
  return {
    type: GET_CRS_CLUSTER_FEATURES_DATA_FAIL,
    payload
  };
};

// Cluster Customer List Data

export const getCrsClusterCustomerListData = (payload) => {
  return {
    type: GET_CRS_CLUSTER_CUSTOMER_LIST_DATA,
    payload
  };
};

export const getCrsClusterCustomerListDataSuccess = (payload) => {
  return {
    type: GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_SUCCESS,
    payload
  };
};

export const getCrsClusterCustomerListDataFail = (payload) => {
  return {
    type: GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_FAIL,
    payload
  };
};

// Cluster Features Category Codes Data

export const getCrsClusterCategoryCodes = (payload) => {
  return {
    type: GET_CRS_FEATURE_CATEGORY_CODES,
    payload
  };
};

export const getCrsClusterCategoryCodesSuccess = (payload) => {
  return {
    type: GET_CRS_FEATURE_CATEGORY_CODES_SUCCESS,
    payload
  };
};

export const getCrsClusterCategoryCodesFail = (payload) => {
  return {
    type: GET_CRS_FEATURE_CATEGORY_CODES_FAIL,
    payload
  };
};

// Reset data

export const resetCrsDashboard = (payload) => {
  return {
    type: RESET_CRS_DASHBOARD
  };
};
